export enum APPLICATION_ENVIRONMENT {
  Local = 'local',
  DisasterRecovery = 'drecovery',
  Testing = 'testing',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}
